import React from "react";
import { Link } from "react-router-dom";

const SalesByItem = ({ resPacket }) => {
    return resPacket?.length > 0 ? (
        <table className="customTable">
            <thead>
                <tr>
                    <td>ORDER DATE</td>
                    <td>CUSTOMER NAME</td>
                    <td>ORDER NO.</td>
                    <td>TOTAL AMOUNT</td>
                    <td>ITEMS</td>
                    
                </tr>
            </thead>
            <tbody>
                {resPacket &&
                    resPacket.map((a, i) => {
                        return (
                            <tr key={i}>
                                <td>{a.salesOrderDate}</td>
                                <td>{a.customerTitle}</td>
                                <td>
                                    <Link to={`/salesorders/${a.recordId}`} target="_blank">
                                        {a.orderNo}
                                    </Link>
                                </td>
                                <td>₹ {Number(a.totalAmount)?.toFixed(2)}</td>
                                {a.items?.map((abc, j) => {
                                    return <td key={j}>{abc.itemTitle} </td>;
                                })}
                            </tr>
                        );
                    })}
            </tbody>
        </table>
    ) : (
        <>No Record found</>
    );
};

export default SalesByItem;
